import { useMemo } from 'react'

import { PaymentMethodType } from '../../../enums/paymentMethodType'
import { useZervantSettings } from '../../../hooks/useZervantSettings'
import { PaymentMethodMap } from '../../../types/paymentMethod'
import { PaymentMethodsSettings } from '../types/paymentMethods/paymentMethodsSettings'

export const usePredefinedPaymentMethodsValues = () => {
  const { data: zervantSettings, hasFailedToLoad, isLoading, refetch } = useZervantSettings()

  const predefinedPaymentMethodsValues: PaymentMethodsSettings = useMemo(() => {
    const defaultBankAccount = zervantSettings?.values?.paymentMethods?.find(
      (paymentMethod): paymentMethod is PaymentMethodMap[PaymentMethodType.IBAN] =>
        paymentMethod?.type === PaymentMethodType.IBAN,
    )
    const paypalEmail = zervantSettings?.values?.paymentMethods?.find(
      (paymentMethod): paymentMethod is PaymentMethodMap[PaymentMethodType.PAYPAL] =>
        paymentMethod?.type === PaymentMethodType.PAYPAL,
    )?.fields.paypal

    const offlinePayment = zervantSettings?.values?.paymentMethods?.find(
      (paymentMethod): paymentMethod is PaymentMethodMap[PaymentMethodType.OTHER] =>
        paymentMethod?.type === PaymentMethodType.OTHER,
    )?.fields.free

    return {
      bank: defaultBankAccount?.fields?.bank,
      iban: defaultBankAccount?.fields?.iban,
      offlinePayment,
      paypalEmail,
      swift: defaultBankAccount?.fields?.swift,
    }
  }, [zervantSettings?.values?.paymentMethods])

  return { hasFailedToLoad, isLoading, predefinedPaymentMethodsValues, refetch }
}
